import React from "react";
import classes from './LoadingIndicator.module.css';

export function LoadingIndicator() {
    return (
      <div className={classes.indicatorWrapper}>
          <div className={classes.indicator} />
      </div>
    )
}